import moment from "moment/moment";
import serverCall from "../serverCall";

const categoryOptions = async () => {
  const response = await serverCall.get(`/events/category`);
  return response;
};
const tireOptions = async () => {
  const response = await serverCall.get(`/events/getAllTier`);
  return response;
};
const RefreshData = async (ids) => {
  const response = await serverCall.post(`events/addData`, ids);
  return response;
};
const allEvent = async (data, option) => {

  const crDate = moment().format("YYYY-MM-DD");
  if (
    (option !== null && option.value === "upcomingevent") ||
    option === "upcomingevent"
  ) {
    data.eventStartDate = crDate;
  }
  if (option !== null && option.value === "pastevent") {
    data.eventEndDate = crDate;
  }
  const response = await serverCall.post(`/events/getAll`, data);
  return response;
};

// New API for fetching all events (simplified)
const getAllEvents = async () => {
  const response = await serverCall.post(`/events/all?status=all`);
  return response;
};

// Dashboard API
const getDashboardData = async (eventId) => {
  const response = await serverCall.post(`/dashboard`, eventId);
  return response;
};
// const allEvent = async (page, limit, categoryid, option) => {
//   const crDate = moment().format("YYYY-MM-DD");
//   let response = `/events?page=${page}&perPage=${limit}`;

//   if (categoryid) {
//     response += `&categoryId=${categoryid}`;
//   }
//   if (
//     (option !== null && option.value === "upcomingevent") ||
//     option === "upcomingevent"
//   ) {
//     response += `&eventStartDate=${crDate}`;
//   }
//   // if (option !== null && option.value === "allevent") {
//   //   response += `&eventStartDate=${crDate}&eventEndDate=${crDate}`;
//   // }
//   if (option !== null && option.value === "pastevent") {
//     response += `&eventEndDate=${crDate}`;
//   }
//   return await serverCall.get(response);
// };
const manWomandata = async (data) => {
  const response = await serverCall.post(`/events/getAthlete`,data)
  return response
}
const startListData = async (id) => {
  const response = await serverCall.get(`/events/program?id=${id}`);
  return response;
};
const athleteData = async (eventId, programId) => {
  const response = await serverCall.get(
    `/events/getAllAthlete?eventId=${eventId}&programId=${programId}`
  );
  return response;
};

const updateData = async (data) => {
  const response = await serverCall.patch(`/events/updateEventData`, data);
  return response;
};

const updateProgramAthletes = async (data) => {
  const response = await serverCall.patch(`/events/sync-athletes`, data);
  return response;
};

const updateProgramResult = async (data) => {
  const response = await serverCall.patch(`/events/updateProgramResult`, data);
  return response;
};

const updateTimestamp = async (data) => {
  const response = await serverCall.patch(`/events/update-timestamp`, data);
  return response;
};

const getWinnerList = async (page, limit, eventId) => {
  const response = await serverCall.get(`/user/winner-list`, {
    params: {
      page,
      limit,
      eventId,
      event_ids: [],
    },
  });
  return response;
};

const getAllWinnersForCSV = async (eventId) => {
  const response = await serverCall.get(`/user/winner-list`, {
    params: {
      page: 1,
      limit: 10000, // Large limit to get all winners
      eventId,
      event_ids: [],
    },
  });
  return response;
};

const getAllUsersWithTeamCount = async (page, limit) => {
  const response = await serverCall.get(`/user/all-users-team-count`, {
    params: {
      page,
      limit,
    },
  });
  return response;
};

const getAllUsersForCSV = async () => {
  const response = await serverCall.get(`/user/all-users-team-count`, {
    params: {
      page: 1,
      limit: 10000, // Large limit to get all users
    },
  });
  return response;
};

const eventService = {
  categoryOptions,
  allEvent,
  getAllEvents,
  getDashboardData,
  manWomandata,
  tireOptions,
  startListData,
  RefreshData,
  athleteData,
  updateData,
  updateProgramAthletes,
  updateProgramResult,
  updateTimestamp,
  getWinnerList,
  getAllWinnersForCSV,
  getAllUsersWithTeamCount,
  getAllUsersForCSV,
};
export default eventService;
